import { getIn } from 'Lib/utilities/util';

/**
 * Filters an array of objects to return unique objects based on a specified path.
 *
 * @param {Array} array - The input array of objects to filter for uniqueness.
 * @param {string} path - The property path used to determine uniqueness within the objects.
 * @returns {Array} - An array containing unique objects based on the specified path.
 */
export default function unique(array, path) {
    // Create a Set to store unique values
    const set = new Set();

    // Use the filter method to iterate through the input array
    return array.filter(item => {
        // Determine the property path to use for comparison
        const itemPath = item && item.value ? 'value' : path;

        // Extract the value at the specified path using getIn function
        const value = getIn(item, itemPath);

        // Check if the value is a duplicate
        const duplicate = set.has(value);

        // Add the value to the Set to keep track of uniqueness
        set.add(value);

        // Return true to keep the item in the filtered array if it's unique and not falsy
        return !duplicate && value;
    });
}
